import { createContext } from 'react';
import { WizardContext } from './Wizard.types';

export const WizardContextValue = createContext<WizardContext>({
    steps: [],
    setIsLoading: () => null,
});

export default WizardContextValue;
